// Core state object
//
'use strict';

var Token = require('../token');


function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token;


module.exports = StateCore;



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it/lib/rules_core/state_core.js
// module id = 538
// module chunks = 0